import { Form } from "@circle-react-uikit/Form";
import { useFormItem } from "../../DefaultEditorV2/useFormItem";

export interface StringFieldProps {
  label: string;
  name: string;
}

export const StringField = ({ name, label }: StringFieldProps) => {
  const { getFormItemProps } = useFormItem();

  return (
    <Form.Item
      name={name}
      label={label}
      {...getFormItemProps({
        // eslint-disable-next-line i18next/no-literal-string -- False positive
        className: "!block",
        // eslint-disable-next-line i18next/no-literal-string -- False positive
        labelClassName: "!mb-1",
      })}
    >
      <Form.Input name={name} />
    </Form.Item>
  );
};
